import styled from 'styled-components';

const arrowIconAspectRatio = 15 / 29; // read from SVG file

interface ArrowProps {
  color: string;
  height: number;
}
export const ArrowIconContainer = styled.div<ArrowProps>`
  width: ${props => props.height * arrowIconAspectRatio}px;
  height: ${props => props.height}px;

  svg {
    line {
      fill: none;
      stroke-miterlimit: 10;
      stroke-width: 3;
      stroke: ${props => props.color};
    }

    polygon {
      fill: ${props => props.color};
    }
  }
`;
